export default __webpack_public_path__ + "static/icon-tile-anatomy-light-b2bc6ebef809946e5a979d58a5ad0a57.png";